import { useEffect } from "react";

// iOS Safari (and Chrome on Android) read the linked manifest at the
// moment the user taps "Add to Home Screen", and use `start_url` +
// `apple-mobile-web-app-title` for the resulting shortcut. The whole
// SaaS shell uses /manifest.json (start_url=/) which means every
// install shortcut lands at the dashboard.
//
// This hook swaps the manifest link + apple title to a kiosk-specific
// pair while the kiosk page is mounted, then restores the originals on
// unmount — letting staff save the Cash Drawer and Time Clock kiosks
// as separate icons on their iPad homescreen.
export default function useKioskManifest({ manifest, title } = {}) {
  useEffect(() => {
    if (!manifest && !title) return undefined;
    const manifestLink = document.querySelector('link[rel="manifest"]');
    const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');

    const prevManifest = manifestLink?.getAttribute("href");
    const prevTitle = appleTitleMeta?.getAttribute("content");
    const prevDocTitle = document.title;

    if (manifest && manifestLink) manifestLink.setAttribute("href", manifest);
    if (title) {
      if (appleTitleMeta) appleTitleMeta.setAttribute("content", title);
      document.title = title;
    }

    return () => {
      if (prevManifest && manifestLink) manifestLink.setAttribute("href", prevManifest);
      if (prevTitle && appleTitleMeta) appleTitleMeta.setAttribute("content", prevTitle);
      if (prevDocTitle) document.title = prevDocTitle;
    };
  }, [manifest, title]);
}
